module.exports = __webpack_public_path__ + "static/media/sukromna_materska_skola.48bb6927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/sukromna_materska_skola.jpg
// module id = 440
// module chunks = 0